import React from "react";
import "./Services.css";
import { MdOutlineLibraryAddCheck } from "react-icons/md";

function Services() {
	return (
		<section id="#services">
			<h5>What I Offer</h5>
			<h2>Services</h2>

			<div className="container services__container">
			<article className="services">
  <div className="service__head">
    <h3>UI/UX Design</h3>
  </div>
  <ul>
    <li className="service__list">
      <MdOutlineLibraryAddCheck className="service__icon" />
      <p>
        <strong>Thorough Research</strong> - I conduct in-depth user and market research to ensure a comprehensive understanding of each project's unique needs.
      </p>
    </li>

    <li className="service__list">
      <MdOutlineLibraryAddCheck className="service__icon" />
      <p>
        <strong>Effective Web Design</strong> - I create streamlined and responsive websites that drive growth and engagement for brands and companies.
      </p>
    </li>

    <li className="service__list">
      <MdOutlineLibraryAddCheck className="service__icon" />
      <p>
        <strong>Intuitive Design Frameworks</strong> - As an experienced UI/UX engineer, I expertly design and deliver wireframes that provide a clear visual understanding of features and user flows for seamless development and testing.
      </p>
    </li>
  </ul>
</article>
				{/* End of UI/UX design*/}

				<article className="services">
					<div className="service__head">
						<h3>Web Development</h3>
					</div>
					<ul>
						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Expert Problem Solver in JavaScript</strong> -: With a solid understanding of advanced JavaScript concepts and data structures, I have honed the skill of algorithmic problem solving, as can be seen in my LeetCode repository available on{" "}
								<a href="https://github.com/Syntax-Read3r/LeetCode">Github</a>.
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Git Version Control</strong> -: I possess a solid understanding of Git workflow and have experience working collaboratively on single repositories, including resolving merge conflicts. I prioritize the importance of maintaining a clean commit history and follow best practices such as avoiding direct push to the main branch in pair programming projects.
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>React Development Expert </strong> -: As a React specialist, I am skilled in building visually stunning, fast, and maintainable component-based websites. My code is also designed with readability in mind to ensure that it can easily be maintained and understood by any intermediate developer and above.
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Laravel Development Expert  </strong> -: As a skilled Laravel developer, I am experienced in building dynamic and robust web applications and websites. I follow best practices and utilize the latest Laravel features to ensure optimal performance, security, and scalability. My code is also designed to be easily maintainable and understandable for both myself and other developers.
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>API Development Expert</strong> -: As an API development specialist, I am skilled in utilizing third-party APIs to create functional and engaging applications. Additionally, I am proficient in using Express to create custom APIs that utilize bespoke data. I prioritize efficient communication and clear documentation to ensure seamless integration and ease of use for all stakeholders.
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Database Development Expert</strong> -: As a skilled developer, I am experienced in utilizing both MongoDB and MySQL to create robust and scalable databases for a variety of applications. I have a thorough understanding of database design and optimization and utilize best practices to ensure optimal performance and scalability. Additionally, I am proficient in creating dynamic database-driven websites that require fast data retrieval and management.
							</p>
						</li>
					</ul>
				</article>
				{/* End of Web Development */}

				<article className="services">
					<div className="service__head">
						<h3>Content Creation</h3>
					</div>
					<ul>
						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>The Marketing Funnel</strong> -: Total understanding of
								the 6 stages of the marketing funnel.{" "}
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Keyword Research</strong> -: Top principle to apply to
								keep up to date with current trends.{" "}
							</p>
						</li>

						<li className="service__list">
							<MdOutlineLibraryAddCheck className="service__icon" />
							<p>
								<strong>Photoshop cs6</strong> -: An enthusiast of digital
								drawing, creativity and photograph editing using photoshop and
								like apps such as DaVinci Resolve and Clip Studi Paint.
							</p>
						</li>
					</ul>
				</article>
				{/* End of  content creation*/}
			</div>
		</section>
	);
}

export default Services;